import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateAppRequestBody,
  IApiGetAppResponseBody,
} from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';
import { onboardingStatusQueryKeyFactory } from '../../Onboarding/hooks/useOnboardingStatusQuery';
import { appQueryKeyFactory } from './useAppQuery';
import { appsQueryKeyFactory } from './useAppsQuery';

export type IUseCreateAppMutationValues = {
  body: IApiCreateAppRequestBody;
};

export const useCreateAppMutation = (): UseMutationResult<
  IApiGetAppResponseBody,
  unknown,
  IUseCreateAppMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateAppMutationValues) =>
      api.apps.create(values.body),
    onSuccess: async (createdApp) => {
      queryClient.setQueryData(
        appQueryKeyFactory({
          appId: createdApp._id,
        })!,
        createdApp,
      );

      await queryClient.invalidateQueries({
        queryKey: appsQueryKeyFactory(),
      });

      await queryClient.invalidateQueries({
        queryKey: onboardingStatusQueryKeyFactory({
          body: {
            target: 'organization',
            id: createdApp.organization?._id,
          },
        }),
      });
    },
  });
};
